import cn from 'classnames'
import settings from '../../settings'

import { useLanguageMenu } from 'mmfintech-checkout-commons'

import { MenuContainer, MenuDropDown, MenuWrapper } from './LanguageMenu.styled'

import ArrowUpIcon from '../../assets/icons/arrow-up.svg'
import ArrowDownIcon from '../../assets/icons/arrow-down.svg'
import LanguageIcon from '../../assets/icons/globe.svg?react'

export const LanguageMenu = () => {
  const {
    dropdownOpened,
    selectedLanguage,
    languages,
    getLanguageName,
    handleDropDownClick,
    handleLanguageChange,
    setRef
  } = useLanguageMenu(settings.languages)

  return selectedLanguage ? (
    <MenuWrapper data-test='language-menu-wrapper' ref={setRef}>
      <MenuContainer className={cn({ opened: dropdownOpened })} onClick={handleDropDownClick}>
        <span className='icon'>
          <LanguageIcon />
        </span>
        <span className='selected'>{getLanguageName(selectedLanguage)}</span>
        <span className='arrow'>
          <img src={dropdownOpened ? ArrowUpIcon : ArrowDownIcon} alt='' />
        </span>
      </MenuContainer>
      <MenuDropDown className={cn({ opened: dropdownOpened })} data-test='language-menu-content'>
        <ul data-test='language-menu-list'>
          {languages.map(v => (
            <li key={v.code} onClick={() => handleLanguageChange(v.code)} data-test='language-menu-item'>
              {v.name}
            </li>
          ))}
        </ul>
      </MenuDropDown>
    </MenuWrapper>
  ) : null
}
